export enum IconType {
  FLATICON,
  IMAGE
}
